class SectionNewsletterPopup {
  constructor() {
    this.popup = document.querySelector('.js-popup');
    this.content = this.popup?.querySelector('.js-popup__content');
    this.overlay = this.popup?.querySelector('.js-popup__overlay');
    this.closeBtn = this.popup?.querySelector('.js-popup__close');

    this.delay = parseInt(this.content?.dataset.delay) || 5000;
    this.cookieDuration = parseInt(this.content?.dataset.cookieDuration) || 172800; // 48h en secondes
    
    this.cookieName = 'newsletter_popup_closed';
    
    this.init();
  }

  init() {
    if (!this.popup || this.isPopupClosed()) return;
    
    this.bindEvents();
    this.scheduleShow();
  }

  bindEvents() {
    this.closeBtn?.addEventListener('click', () => this.closePopup());
    this.overlay?.addEventListener('click', () => this.closePopup());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.popup.style.display === 'block') {
        this.closePopup();
      }
    });
  }

  scheduleShow() {
    setTimeout(() => {
      this.showPopup();
    }, this.delay);
  }

  showPopup() {
    if (this.isPopupClosed()) return; 
    
    this.overlay.style.display = 'block';
    this.popup.style.display = 'flex';
    
    requestAnimationFrame(() => {
      this.overlay.classList.add('opacity-100');
      this.content.classList.remove('translate-y-full', 'opacity-0');
      this.content.classList.add('translate-y-0', 'opacity-100');
    });
  }

  closePopup() {
    this.overlay.classList.remove('opacity-100');
    this.content.classList.add('translate-y-full', 'opacity-0');
    this.content.classList.remove('translate-y-0', 'opacity-100');
    
    setTimeout(() => {
      this.overlay.style.display = 'none';
      this.popup.style.display = 'none';
    }, 500);
    
    this.setCookie();
  }

  setCookie() {
    const expires = new Date();
    expires.setTime(expires.getTime() + (this.cookieDuration * 1000));
    document.cookie = `${this.cookieName}=true; expires=${expires.toUTCString()}; path=/`;
  }

  isPopupClosed() {
    return document.cookie.includes(`${this.cookieName}=true`);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SectionNewsletterPopup();
});
